import { AccountCardData } from "../Dashboard card data";
import CardRender from "../DashboardCardRender";
import NavBar from "../NavBar";
import "./Account.css";
import AccGraphRender from "../AccGraphRender";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import AccScaleRender from "../AccScaleRender";
import AccScaleData from "../AccScaleData";
import DashBoardInvoiceTable from "../DashBoardInvoiceTable";
import DotsComponent from "../DotsComponent";
import PieCardRender from "../PieCardRender";
import GraphLabel3 from "../Components/GraphLabel3";

const AccDashboard = () => {

  return (
    <div>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Accounting </span>
          <span className="color"> &#62; </span>
          <span className="color"> Dashboard</span>
        </p>
      </div>

      <div className="dashborad_title">
        <h1>Dashboard</h1>
      </div>

      <div id="right-content-cards">
        <CardRender comp={AccountCardData.slice(0,3)} />
        <PieCardRender data={PieCardData} filling={fillingData} pieColor={PIECOLORS} pieIndicator={pieIndicator}/>
        <CardRender comp={AccountCardData.slice(3,5)} />
      </div>

      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph-II">
        <DotsComponent/>
          <div className="graph">
            <div className="graph_heading">
              <h1 className="Graph_title">CASH FLOW</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel3 color={["#394A7E","#F7762E", "#20BF55"]} 
            value={['Incoming', 'Outgoing','Profit']}
          />
          <AccGraphRender />
        </div>
        <div className="progress-card">
          <AccScaleRender data={AccScaleData[0]} />
          <AccScaleRender data={AccScaleData[1]} />
        </div>
      </div>

     <DashBoardInvoiceTable />
    </div>
  );
};

export default AccDashboard;
const PieCardData= {
  card1up1: "₹50K",
  card1up2: "variance",
  dot1: "variance",
  dot2: "budget",
  dot3: "actual",
  dot4: "",
  card1dnP: "BUDGET VARIANCE",
}
const fillingData = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 850 },
];
const PIECOLORS = ["#FFE754", "#F7762E"];
const pieIndicator = ["#ECECEC","#FFE754", "#F7762E"]